import React, {Component} from 'react';
import ContentPanel from '../../components/ContentPanel/ContentPanel';
import Skeleton from '../../components/Skeleton/Skeleton';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import {REQUEST_NEWS_DATA} from "../../actions/newsActions";
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import ContentLinkRenderer from '../../components/ContentLinkRenderer/ContentLinkRenderer';
import moment from "moment";
import ContentRenderer from "../../components/ContentRenderer/ContentRenderer";
import store from "../../store";
import {Helmet} from "react-helmet";


const mapStateToProps = state => {
  return {
    newsData: state.newsData
  }
};

const mapDispatchToProps = dispatch => ({
  getNewsData: () => dispatch({type: REQUEST_NEWS_DATA})
});

class News extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.newsData).length) {
      this.props.getNewsData();
    }
  };

  getNewsView = () => {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "About" ? row.sections.map((section) => {
                          return section.title === "News" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/about/page-components/text-block/news-heading.html"
        />
        <div className="cards-list__archive-block-container mtm">
          {
            this.props.newsData.news
              .sort((a, b) => {
                const timestampA = moment(a.date, 'MM/DD/YYYY').unix();
                const timestampB = moment(b.date, 'MM/DD/YYYY').unix();
                return timestampB - timestampA;
              })
              .map((item, index) => {
              return (
                <div key={index} className="cards-list__archive-block cards-list__archive-block--news">
                  <div key={index} className="cards-list__archive-item">
                    <p className="cards-list__archive-item-date">{item.date}</p>
                    {
                      (item.detailContent && item.detailContent.type && item.detailContent.value) ?
                        <ContentLinkRenderer
                          contentType={item.detailContent.type}
                          value={item.detailContent.value}
                          linkContent={item.title}
                          className="cards-list__archive-item-title-link"
                          target={item.detailContent.target}
                          pathForItem="/about/news/news-item"
                          id={item.id}
                        />
                        :
                        <p className="cards-list__archive-item-title-link mtn">{item.title}</p>
                    }
                  </div>
                  {
                    (item.content && item.content.type && item.content.value) ?
                      <ContentRenderer
                        contentType={item.content.type}
                        value={item.content.value}
                      />
                      :
                      null
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  };

  render() {
    if (!Object.keys(this.props.newsData).length) {
      return (<Skeleton type="IFRAME"/>)
    } else {
      return this.getNewsView();
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(News));



// WEBPACK FOOTER //
// ./src/pages/About/News.js